import React, { Component } from 'react'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils.js'
import AnnexureDocumentUploadUI from './AnnexureDocumentUploadUI.js'

class AnnexureDocumentUploadSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      // Annexure 4 upload state
      annexure4UploadMode: false,
      annexure4UploadSubmitted: false,
      annexure4UploadSuccessMsg: null,
      annexure4UploadErrorList: [],
      // Annexure 5 upload state
      annexure5UploadMode: false,
      annexure5UploadSubmitted: false,
      annexure5UploadSuccessMsg: null,
      annexure5UploadErrorList: [],
      //
      deleteAnnexureIVFileMode: false,
      deleteAnnexureVFileMode: false
    }
  }

  render() {
    return (
      <AnnexureDocumentUploadUI
        context={this.props.context}
        loan={this.props.loan}
        errorList={this.state.errorList}
        // Annexure 4 props
        annexure4UploadMode={this.state.annexure4UploadMode}
        annexure4UploadSubmitted={this.state.annexure4UploadSubmitted}
        annexure4UploadSuccessMsg={this.state.annexure4UploadSuccessMsg}
        annexure4UploadErrorList={this.state.annexure4UploadErrorList}
        onAnnexure4UploadClick={() => { this.setState({ annexure4UploadMode: true }) }}
        onAnnexure4UploadCancel={() => { this.setState({ annexure4UploadMode: false }) }}
        onAnnexure4Upload={this.onAnnexure4Upload}
        // Annexure 5 props
        annexure5UploadMode={this.state.annexure5UploadMode}
        annexure5UploadSubmitted={this.state.annexure5UploadSubmitted}
        annexure5UploadSuccessMsg={this.state.annexure5UploadSuccessMsg}
        annexure5UploadErrorList={this.state.annexure5UploadErrorList}
        onAnnexure5UploadClick={() => { this.setState({ annexure5UploadMode: true }) }}
        onAnnexure5UploadCancel={() => { this.setState({ annexure5UploadMode: false }) }}
        onAnnexure5Upload={this.onAnnexure5Upload}
        // Common props
        onRefreshClick={this.props.onRefreshClick}
        // Download props
        onAnnexure4FileDownload={this.onAnnexure4FileDownload}
        onAnnexure5FileDownload={this.onAnnexure5FileDownload}
        // Delete props
        deleteAnnexureIVFileMode={this.state.deleteAnnexureIVFileMode}
        onAnnexureIVFileDeleteClick={this.onAnnexureIVFileDeleteClick}
        deleteAnnexureVFileMode={this.state.deleteAnnexureVFileMode}
        onAnnexureVFileDeleteClick={this.onAnnexureVFileDeleteClick}
        selectedFile={this.state.selectedFile}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onAnnexure4Upload = (fileId, fileName, fileType, fileSize, customFileName) => {
    this.setState({
      annexure4UploadSubmitted: true,
      annexure4UploadSuccessMsg: null,
      annexure4UploadErrorList: []
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/documents/loanAgreement/annexureIV/validation`,
      this.onAnnexure4UploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      },
      customFileName: customFileName === undefined ? '' : customFileName
    }
    )
  }

  onAnnexure4UploadCallback = (response) => {
    this.setState({ annexure4UploadSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      annexure4UploadSuccessMsg: response.success,
      annexure4UploadErrorList: errorList
    })

    if (this.props.onRefreshClick) {
      this.props.onRefreshClick('noBusy')
    }

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          annexure4UploadSuccessMsg: null
        })
      }, 2000)
    }
  }

  onAnnexure5Upload = (fileId, fileName, fileType, fileSize, customFileName) => {
    this.setState({
      annexure5UploadSubmitted: true,
      annexure5UploadSuccessMsg: null,
      annexure5UploadErrorList: []
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/documents/loanAgreement/annexureV/validation`,
      this.onAnnexure5UploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      },
      customFileName: customFileName === undefined ? '' : customFileName
    }
    )
  }

  onAnnexure5UploadCallback = (response) => {
    this.setState({ annexure5UploadSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      annexure5UploadSuccessMsg: response.success,
      annexure5UploadErrorList: errorList
    })

    if (this.props.onRefreshClick) {
      this.props.onRefreshClick('noBusy')
    }

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          annexure5UploadSuccessMsg: null
        })
      }, 2000)
    }
  }

  onAnnexure4FileDownload = (event) => {
    let fileName = event.currentTarget.getAttribute('data-file-name')
    const downloadUrl = `/api/su/loans/${this.props.loan.loanId}/documents/loanAgreement/annexureIV/${fileName}/fileDownloadSignedUrl`

    RestApiUtils.get(this.props.context, downloadUrl, (response) => {
      if (response.signedUrl && response.signedUrl.signedUrl) {
        const link = document.createElement('a')
        link.href = response.signedUrl.signedUrl
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    })
  }

  onAnnexure5FileDownload = (event) => {
    let fileName = event.currentTarget.getAttribute('data-file-name')
    const downloadUrl = `/api/su/loans/${this.props.loan.loanId}/documents/loanAgreement/annexureV/${fileName}/fileDownloadSignedUrl`

    RestApiUtils.get(this.props.context, downloadUrl, (response) => {
      if (response.signedUrl && response.signedUrl.signedUrl) {
        const link = document.createElement('a')
        link.href = response.signedUrl.signedUrl
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    })
  }

  onAnnexureIVFileDeleteClick = (event) => {
    let fileName = event.target.getAttribute('data-file-name')
    if (window.confirm(`Are you sure you want to delete ${fileName}?`)) {
      this.setState({
        deleteAnnexureIVFileMode: true
      })

      RestApiUtils.delete(this.props.context,
        `/api/su/loans/${this.props.loan.loanId}/documents/loanAgreement/annexure/${fileName}`,
        this.onAnnexureIVFileDeleteClickCallback, {}
      )
    }
  }

  onAnnexureIVFileDeleteClickCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      deleteAnnexureIVFileMode: false,
    })

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null, errorList: [] })
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  onAnnexureVFileDeleteClick = (event) => {
    let fileName = event.target.getAttribute('data-file-name')
    if (window.confirm(`Are you sure you want to delete ${fileName}?`)) {
      this.setState({
        deleteAnnexureVFileMode: true,
        selectedFile: fileName
      })

      RestApiUtils.delete(this.props.context,
        `/api/su/loans/${this.props.loan.loanId}/documents/loanAgreement/annexure/${fileName}?isAnnexureV=true`,
        this.onAnnexureVFileDeleteClickCallback, {}
      )
    }
  }

  onAnnexureVFileDeleteClickCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      deleteAnnexureVFileMode: false,
    })

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null, errorList: [] })
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }
}

export default AnnexureDocumentUploadSF
